import { render } from "./EditarView.vue?vue&type=template&id=8bb4d458"
import script from "./EditarView.vue?vue&type=script&lang=js"
export * from "./EditarView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__